import { render, staticRenderFns } from "./NumerationComponent.vue?vue&type=template&id=648f0ec4&scoped=true&lang=pug"
import script from "./NumerationComponent.vue?vue&type=script&lang=ts"
export * from "./NumerationComponent.vue?vue&type=script&lang=ts"
import style0 from "./NumerationComponent.vue?vue&type=style&index=0&id=648f0ec4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f0ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648f0ec4')) {
      api.createRecord('648f0ec4', component.options)
    } else {
      api.reload('648f0ec4', component.options)
    }
    module.hot.accept("./NumerationComponent.vue?vue&type=template&id=648f0ec4&scoped=true&lang=pug", function () {
      api.rerender('648f0ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Numeration/NumerationComponent.vue"
export default component.exports